import { format } from '@/utils/date.utils'

export default class HealthLandingInsured {
  public birthDate: Date | null
  public firstSurname: string | null
  public name: string | null
  public riskNumber: number | null
  public secondSurname: string | null

  public insuranceName: string | null = null
  public policynumber: string | null = null
  public healthCard: File[] = []
  public healthCardBase64: string | null = null
  public lastReceipt: File[] = []
  public lastReceiptBase64: string | null = null

  constructor(data: Partial<HealthLandingInsured> = {}) {
    this.birthDate = data.birthDate ?? null
    this.firstSurname = data.firstSurname ?? null
    this.name = data.name ?? null
    this.riskNumber = data.riskNumber ?? null
    this.secondSurname = data.secondSurname ?? null
  }

  get fullName() {
    return `${this.name} ${this.firstSurname} ${this.secondSurname}`
  }

  get birthDateString() {
    return format(this.birthDate)
  }
}
